<template>
  <div id="app">
    <Index v-show = "isPC === false" />
    <Mindex v-show = "isPC === true" />
  </div>
</template>

<script>
import Index from './components/index.vue'
import Mindex from './components/mbindex.vue'

export default {
  name: 'app',
  components: {
    Index,Mindex
  },
  data() {
    return {
      isPC: false
    };
  },
  methods: {
    getScreen() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        // 移动端调用的函数
        this.isPC= true;
        console.log("手机端");
      } else {
        // PC端调用的函数
        this.isPC= false;
        console.log("pc端");
      }
    },
  },
  mounted() {
    // 初始检查
    this.getScreen();
    // 添加窗口大小改变的监听
    window.addEventListener('resize', this.getScreen);
  },
  beforeDestroy() {
    // 移除监听
    window.removeEventListener('resize', this.getScreen);
  }

}
</script>

<style>

</style>
